import {StyledGrid} from 'presentation/components';
import React from 'react';
import {OrientationCard} from '../OrientationCard';
import {ORIENTATION_CARDS} from './constants';
import {useDrawerControllerStore} from '../../store/useDrawerControllerStore';

export const OrientationCardsGrid = () => {
	const setDrawerIndex = useDrawerControllerStore(state => state.setDrawerIndex);
	return (
		<StyledGrid.Root spacing={1} paddingBottom={8}>
			{ORIENTATION_CARDS.map(card => (
				<StyledGrid.Item key={card.id} xs={12} sm={12} md={12} lg={4} xl={4}>
					<OrientationCard
						orientations={card}
						handleClick={() => setDrawerIndex(card.id)}
					/>
				</StyledGrid.Item>
			))}
		</StyledGrid.Root>
	);
};
